import {Modal} from 'react-bootstrap'
import React, {useState, useEffect} from 'react'
import '../addStock.css'
import { toast } from 'react-toastify'

export const EditBillDetailModal = (props: any) => {
  const [totalAmount, setTotalAmount] = useState(props.billDetails.totalAmount)
  const [cashDiscount, setCashDiscount] = useState(props.billDetails.cashDiscount)
  const [discountAmount, setDiscountAmount] = useState(props.billDetails.discountAmount)
  const [sgstPayable, setSgstPayable] = useState(props.billDetails.sgstPayable)
  const [cgstPayable, setCgstPayable] = useState(props.billDetails.cgstPayable)

  useEffect(() => {
    if (props.modalState) {
      setTotalAmount(props.billDetails.totalAmount.toFixed(2))
      setCashDiscount(props.billDetails.cashDiscount.toFixed(2))
      setDiscountAmount(props.billDetails.discountAmount.toFixed(2))
      setSgstPayable(props.billDetails.sgstPayable.toFixed(2))
      setCgstPayable(props.billDetails.cgstPayable.toFixed(2))
    }
  }, [props.modalState, props.billDetails])

  const handleUpdate = () => {
     
    const updatedValues = {
      totalAmount: Number(totalAmount),
      cashDiscount: Number(cashDiscount),
      discountAmount: Number(discountAmount),
      sgstPayable: Number(sgstPayable),
      cgstPayable: Number(cgstPayable),
    }

    const totalDiscount = updatedValues.cashDiscount + updatedValues.discountAmount + updatedValues.sgstPayable + updatedValues.cgstPayable;  

    if(updatedValues.totalAmount< totalDiscount){
       toast.error("Total Discount cannot be greater than Total Amount");
    
      return;
    }


    props.onUpdateField(updatedValues)
    props.closeModal()
  }

  return (
    <Modal
      show={props.modalState}
      dialogClassName='ePulse-modal ePulse-modal-50w'
      onHide={() => props.closeModal()}
      backdrop='static'
    >
      <Modal.Header className='border-0' closeButton>
        <span className='fs-3 fw-bold'>Edit bill details</span>
      </Modal.Header>
      <Modal.Body className='container' />
      <div className='ePulse-modal-content'>
        <div className='modal-body'>
          <div className='form-row'>
            <label>Total Amount:</label>
            <input
              type='number'
              className='form-control'
              value={totalAmount}
              onChange={(e) => setTotalAmount(e.target.value)}
            />
          </div>
          <div className='form-row'>
            <label>Cash Discount:</label>
            <input
              type='number'
              className='form-control'
              value={cashDiscount}
              onChange={(e) => setCashDiscount(e.target.value)}
            />
          </div>
          <div className='form-row'>
            <label>Discount Amount:</label>
            <input
              type='number'
              className='form-control'
              value={parseFloat(discountAmount)}
              onChange={(e) => setDiscountAmount(e.target.value)}
            />
          </div>
          <div className='form-row'>
            <label>SGST Payable:</label>
            <input
              type='number'
              className='form-control'
              value={sgstPayable}
              onChange={(e) => setSgstPayable(e.target.value)}
            />
          </div>
          <div className='form-row'>
            <label>CGST Payable:</label>
            <input
              type='number'
              className='form-control'
              value={cgstPayable}
              onChange={(e) => setCgstPayable(e.target.value)}
            />
          </div>
        </div>

        <div className='btn-row'>
          <button className='ePulse-btn-primary' type='button' onClick={() => handleUpdate()}>
            Update
          </button>
        </div>
      </div>
    </Modal>
  )
}
